<div class="date-and-slot-picker" *ngIf="(calendarDataLoaded | async) === false">
    <ngb-datepicker #dp [(ngModel)]="model" (navigate)="date = $event.next" navigation="arrows" [markDisabled]="isDisabled"></ngb-datepicker>
    <div class="slot-section" *ngIf="slots.length > 0">
        <div class="slot" [ngClass]="{ selected: selectedSlot === slot }" (click)="selectSlot(slot)" *ngFor="let slot of slots">
            <span class="slot-label">{{ slot.label }}</span>
        </div>
    </div>
</div>
